import React from 'react';
import { prettyDateInterval, getDateInterval } from '../components/common/dates';
import { Spacer } from '../components/common/Decorations';
import '../styles/ExperiencePage.css';

const ExperiencePDFTemplate = ({ experienceData }) => {
  const stackTitle = "МОЙ СТЕК";
  const experienceTitle = "МОЙ ОПЫТ";

  return (
    <div className='contentPDF'>
        <div style={{ 
            marginBottom: '5px', 
            textAlign: 'right', 
            fontSize: '10px', 
            color: '#999' 
            }}>
        Сгенерировано {new Date().toLocaleDateString('ru-RU')}
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ width: "30%" }}>
                <img style={{ width: "100%" }} src={`${process.env.PUBLIC_URL}/images/avatar.png`} crossOrigin="anonymous" alt="Avatar" />
            </div>
            <div style={{ width: "70%", padding: "10px 30px" }}>
                <h2 style={{ "margin": "5px 0", "padding": "0"}}>ШИРКО Илья Владимирович</h2>
                <h3 style={{ "margin": "5px 0", "padding": "0"}}>MIDDLE Python разработчик</h3>
                <br/>
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                        <td style={{ padding: "3px 10px", textAlign: "left" }}>Город проживания:</td>
                        <td style={{ padding: "3px 10px", textAlign: "left" }}>Санкт-Петербург</td>
                        </tr>
                        <tr>
                        <td style={{ padding: "3px 10px", textAlign: "left" }}>Telegram:</td>
                        <td style={{ padding: "3px 10px", textAlign: "left" }}><a style={{ "font-decoration": "underline" }} href="https://t.me/IlyaShirko">IlyaShirko</a></td>
                        </tr>
                        <tr>
                        <td style={{ padding: "3px 10px", textAlign: "left" }}>Email:</td>
                        <td style={{ padding: "3px 10px", textAlign: "left" }}><a style={{ "font-decoration": "underline" }} href="mailto:ilyashirko@gmail.com">ilyashirko@gmail.com</a></td>
                        </tr>
                        <tr>
                        <td style={{ padding: "3px 10px", textAlign: "left" }}>Homepage:</td>
                        <td style={{ padding: "3px 10px", textAlign: "left" }}><a style={{ "font-decoration": "underline" }} href="https://ilyashirko.dev">ilyashirko.dev</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <hr className="experienceDividerPDF"/>
        <div className="title"><strong>{stackTitle}</strong></div>
        {experienceData.stack_summary.map((group) => (
        <div key={group.category} className="experienceStackChapterPDF">
            {group.items.map((item) => (
            <div key={item} className="experienceStackItemPDF">{item}</div>
            ))}
        </div>
        ))}
        <hr className="experienceDividerPDF"/>
        <div className="title"><strong>{experienceTitle}</strong></div>

        {experienceData.experiences.map((experience, index) => (
        <React.Fragment key={experience.company}>
                <br style={{ height: '5px' }} />
                <span className="experienceTitlePDF"><strong>{experience.company}</strong></span>
                <span className="experiencePositionPDF"><strong>{experience.position}</strong></span>
                <p className="experiencePeriodPDF">{prettyDateInterval(experience.employed_at, experience.fired_at)} ({getDateInterval(experience.employed_at, experience.fired_at)})</p>
                <div className="experienceStackChapterPDF">
                    {experience.stack.map((stack) => (
                    <div key={stack} className="experienceStackItemPDF">{stack}</div>
                    ))}
                </div>
                {/* <div className="experienceResponsibility"> */}
                <span className="experienceResponsibilityTitlePDF"><strong>ОБЯЗАННОСТИ</strong></span>
                {experience.responsibilities.map((row, i) => (
                <p key={i} className="experienceResponsibilityItem" style={{"font-size":"12px"}}>{row}</p>
                ))}
                {/* </div>
                <div className="experienceResponsibility"> */}
                <span className="experienceResponsibilityTitlePDF"><strong>ДОСТИЖЕНИЯ</strong></span>
                {experience.achievements.map((row, i) => (
                <p key={i} className="experienceResponsibilityItem" style={{"font-size":"12px"}}>{row}</p>
                ))}
                {/* </div> */}
                <br />

            
            {/* Добавляем горизонтальную линию, если это не последний элемент */}
            {index < experienceData.experiences.length - 1 && <hr className="experienceDividerPDF"/>}

        </React.Fragment>
        ))}
        {/* <ExportToPDF /> */}
        
    </div>
      
  );
};

export default ExperiencePDFTemplate;